module.exports = __webpack_public_path__ + "static/img/image20.33bcce4.png";


//////////////////
// WEBPACK FOOTER
// ./src/newpage/static/images/bind-device-v2/image20.png
// module id = ylxl
// module chunks = 1